import * as Yup from "yup";

const ValidationCancellBilling = Yup.object().shape({
  type: Yup.string().required("El campo es requerido"),
});


export default ValidationCancellBilling;